let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("21Ty3")).then(() => parcelRequire('eTf4e'));